import { ChatsPage } from "./modules/chats/ChatsPage";
import { CHATS_PATH } from "./paths";
import { Routes, Route } from "react-router-dom";
import { AccountOutlet } from "./modules/account/AccountOutlet";
import { LoginPage } from "./modules/account/pages/LoginPage";
import { LayoutProvider, NotFoundPage, NavigateWithSearch } from "@synota-io/synota-shared-ui";
import { LayoutContainer } from "./shared/layout/LayoutContainer";
import { HomePage } from "./modules/dashboard/pages/HomePage";
import { DashboardOutlet } from "./modules/dashboard/DashboardOutlet";
import {
  ACCOUNT_LOGIN_PATH,
  ACCOUNT_PATH,
  ACCOUNT_SIGNUP_PATH,
  CONTRACT_ADHOC_INVOICES_PATH,
  CONTRACT_INVOICES_INVOICE_DETAILS_PATH,
  CONTRACT_INVOICES_PATH,
  CONTRACT_PAYMENTS_PATH,
  CONTRACTS_DETAIL_PATH,
  CONTRACTS_PATH,
  HOME_PATH,
  NODE_LINK_USERS_PATH,
  NODE_USER_DETAILS_PATH,
  NODES_BLUE_PENGUIN_PATH,
  NODES_BLUE_PENGUIN_UNASSIGNED_PATH,
  NODES_PATH,
  REPORTS_PATH,
  USER_ACCOUNT_PATH,
  USER_ACCOUNT_UPDATE_PATH,
  USER_PATH,
  USER_SERVICE_CHARGES_INVOICES_PATH,
  USER_SERVICE_CHARGES_PATH,
  USER_SERVICE_CHARGES_PAYMENTS_PATH,
  USERS_PATH,
} from "./paths";
import { SignupPage } from "./modules/account/pages/SignupPage";
import { ContractsPage } from "./modules/dashboard/pages/ContractsPage";
import { ContractDetailPage } from "./modules/dashboard/pages/ContractDetailsPage";
import { ReportsOutlet } from "./modules/reports/ReportsOutlet";
import { ReportsPage } from "./modules/reports/pages/ReportsPage";
import { IS_ENABLED_REPORTS } from "./utils/environment";
import { ContractDetailsOutlet } from "./modules/dashboard/contracts/ContractDetailsOutlet";
import { UsersPage } from "./modules/dashboard/pages/UsersPage";
import { UserSettingsPage } from "./modules/dashboard/pages/UserSettingsPage";
import { UserServiceChargesPage } from "./modules/dashboard/pages/UserServiceChargesPage";
import { ContractReportsOutlet } from "./modules/dashboard/contracts/ContractReportsOutlet";
import { ServiceChargesOutlet } from "./modules/dashboard/service-charges/ServiceChargesOutlet";
import { ServiceChargeInvoicesTable } from "./modules/dashboard/service-charges/components/ServiceChargeInvoicesTable";
import { ServiceChargePaymentsTable } from "./modules/dashboard/service-charges/components/ServiceChargePaymentsTable";
import { InvoicesTable } from "./modules/dashboard/invoices/components/InvoicesTable";
import { PaymentsTable } from "./modules/dashboard/payments/components/PaymentsTable";
import { NodesOutlet } from "./modules/nodes/NodesOutlet";
import { NodeUrlsPage } from "./modules/nodes/pages/NodeUrlsPage";
import { ProtectedPage } from "./shared/pages/ProtectedPage";
import { BluePenguinUsersPage } from "./modules/nodes/pages/BpUsersPage";
import { AdhocInvoicesTable } from "./modules/dashboard/adhoc/components/AdhocInvoicesTable";

export function AppRoutes() {
  return (
    <Routes>
      <Route path={ACCOUNT_PATH} element={<AccountOutlet />}>
        <Route index element={<NavigateWithSearch replace to={ACCOUNT_LOGIN_PATH} />} />
        <Route path={ACCOUNT_LOGIN_PATH} element={<LoginPage />} />
        <Route path={ACCOUNT_SIGNUP_PATH} element={<SignupPage />} />
      </Route>

      <Route
        path={HOME_PATH}
        element={
          <ProtectedPage>
            <LayoutProvider>
              <LayoutContainer />
            </LayoutProvider>
          </ProtectedPage>
        }
      >
        <Route element={<DashboardOutlet />}>
          <Route index element={<HomePage />} />
          <Route path={CONTRACTS_PATH} element={<ContractsPage />} />
          <Route path={CHATS_PATH} element={<ChatsPage />} />
          <Route element={<ContractDetailsOutlet />}>
            <Route path={CONTRACTS_DETAIL_PATH} element={<ContractDetailPage />} />
          </Route>
          <Route element={<ContractReportsOutlet />}>
            <Route path={CONTRACT_INVOICES_INVOICE_DETAILS_PATH} element={<InvoicesTable />} />
            <Route path={CONTRACT_INVOICES_PATH} element={<InvoicesTable />} />
            <Route path={CONTRACT_PAYMENTS_PATH} element={<PaymentsTable />} />
            <Route path={CONTRACT_ADHOC_INVOICES_PATH} element={<AdhocInvoicesTable />} />
          </Route>
          <Route path={USERS_PATH} element={<UsersPage />} />
          <Route path={USER_PATH} element={<UsersPage />} />
          <Route path={USER_ACCOUNT_PATH} element={<UserSettingsPage />} />
          <Route path={USER_ACCOUNT_UPDATE_PATH} element={<UserSettingsPage />} />
          <Route element={<ServiceChargesOutlet />}>
            <Route path={USER_SERVICE_CHARGES_PATH} element={<UserServiceChargesPage />} />
            <Route
              path={USER_SERVICE_CHARGES_INVOICES_PATH}
              element={<ServiceChargeInvoicesTable />}
            />
            <Route
              path={USER_SERVICE_CHARGES_PAYMENTS_PATH}
              element={<ServiceChargePaymentsTable />}
            />
          </Route>
        </Route>
      </Route>

      <Route
        path={NODES_PATH}
        element={
          <ProtectedPage adminOnly>
            <LayoutProvider>
              <LayoutContainer />
            </LayoutProvider>
          </ProtectedPage>
        }
      >
        <Route element={<NodesOutlet />}>
          <Route index element={<NodeUrlsPage />} />
          <Route path={NODE_USER_DETAILS_PATH} element={<NodeUrlsPage />} />
          <Route path={NODE_LINK_USERS_PATH} element={<NodeUrlsPage />} />
        </Route>
      </Route>

      <Route
        path={NODES_BLUE_PENGUIN_PATH}
        element={
          <ProtectedPage adminOnly>
            <LayoutProvider>
              <LayoutContainer />
            </LayoutProvider>
          </ProtectedPage>
        }
      >
        <Route element={<NodesOutlet />}>
          <Route index element={<BluePenguinUsersPage />} />
          <Route path={NODES_BLUE_PENGUIN_UNASSIGNED_PATH} element={<BluePenguinUsersPage />} />
        </Route>
      </Route>

      {IS_ENABLED_REPORTS && (
        <Route
          path={REPORTS_PATH}
          element={
            <ProtectedPage adminOnly>
              <LayoutProvider>
                <LayoutContainer />
              </LayoutProvider>
            </ProtectedPage>
          }
        >
          <Route element={<ReportsOutlet />}>
            <Route index element={<ReportsPage />} />
          </Route>
        </Route>
      )}

      <Route path="*" element={<NotFoundPage home />} />
    </Routes>
  );
}
